import { render, staticRenderFns } from "./Allergies.vue?vue&type=template&id=402eab3a"
import script from "./Allergies.vue?vue&type=script&lang=js"
export * from "./Allergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports